import { render, staticRenderFns } from "./Estudy.vue?vue&type=template&id=590fc0bc&"
import script from "./Estudy.vue?vue&type=script&lang=js&"
export * from "./Estudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports